import { render, staticRenderFns } from "./ReSendQRCodePage.vue?vue&type=template&id=10253eab&"
import script from "./ReSendQRCodePage.vue?vue&type=script&lang=js&"
export * from "./ReSendQRCodePage.vue?vue&type=script&lang=js&"
import style0 from "./ReSendQRCodePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports